import { render } from "./EntitySelectorPlanilhaTrechos.vue?vue&type=template&id=9514792a"
import script from "./EntitySelectorPlanilhaTrechos.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorPlanilhaTrechos.vue?vue&type=script&lang=ts"
script.render = render

export default script